import { render, staticRenderFns } from "./awsCostsChart.vue?vue&type=template&id=474ce5b3&"
import script from "./awsCostsChart.vue?vue&type=script&lang=ts&"
export * from "./awsCostsChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports